import { render, staticRenderFns } from "./PowerBarChart.vue?vue&type=template&id=9f4adc2e&scoped=true&"
import script from "./PowerBarChart.vue?vue&type=script&lang=js&"
export * from "./PowerBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4adc2e",
  null
  
)

export default component.exports